export enum CreatorViewsKeys {
  SEATS = 'seats',
  BASE_ELEMENTS = 'baseElements',
  SECTORS = 'sectors',
  ROWS = 'rows',
}
